function Introduction() {
  return (
    <section className='mt-16' id='about'>
      <div className='max-w-7xl mx-auto px-4 sm:px-6 grid grid-cols-7 gap-y-16 sm:gap-16 w-full'>
        <div className='col-span-7 lg:col-span-4'>
          <h3 className='text-3xl font-black text-text-main mb-3 leading-tighter'>Starting a company is lonely.</h3>
          <p className='text-md text-text-main mb-3'>
            You have to make difficult decisions every day with imperfect information on problems you’ve likely never
            faced before. It’s daunting.
          </p>
          <p className='text-md text-text-main mb-3'>
            In our experience, the best way to overcome the challenges is to learn from the wins and mistakes of others,
            and to surround yourself with founders who’ve been there, done that.
          </p>
          <p className='text-md text-text-main mb-3'>
            Whether you’re in the thick of it in Singapore or Indonesia, or you’re a SaaS founder in Vietnam, finding
            your people is tough.
          </p>
          <p className='text-md text-text-main mb-3'>But when you do find them, it’s life changing.</p>
          <p className='text-md text-text-main mb-3'>And that’s what The 100 Club is for.</p>
          <p className='text-md text-text-main mb-3'>
            Joining The 100 Club gives you immediate access to a tribe of founders and entrepreneurs who are going
            through the same things as you. Members consistently call it “life changing”.
          </p>
        </div>
        <div className='col-span-6 lg:col-span-3'>
          <div className='bg-highlight-eggshell p-7 rounded-md border mb-10'>
            <p>
              "Entrepreneurship is a lonely journey. Whenever you try to share your experiences you’ll realise that most
              of your friends in corporate jobs wouldn’t understand. The mastermind groups bring together like-minded
              individuals which makes the journey a little less excruciating."
            </p>
            <h4 className='text-lg font-black mt-4'>Wei Jun, Founder of Lalia</h4>
          </div>
          <div className='bg-highlight-eggshell p-7 rounded-md border'>
            <p>
              "Finding a network of founders who have taken similar roads to you is hard. The 100 Club has accelerated
              my network growth, and I have met dedicated and friendly founders who are happy to share their journeys
              and solve problems together."
            </p>
            <h4 className='text-lg font-black mt-4'>Ajinkya, Founder of SeamlessXR</h4>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Introduction;
